import { Button, Spacer, VDBText } from "@components/atoms";
import { ButtonCategory, ButtonType } from "@components/atoms/Button/types";
import { SpaceType } from "@components/atoms/Spacer/types";
import styled from "styled-components/native";
import { DefaultTheme } from "styled-components/native";
import { css } from "styled-components/native";

type NoMatchesProps = {
  handleOnPressExploreProducts: () => void;
  t: any;
  typography: any;
  theme: DefaultTheme;
};

export const NoRecentSearch = ({ t, typography, theme }: any) => {
  return (
    <OverLay>
      <CenteredLabelsContainer>
        <CenteredLabel type={typography["H3-M"]} color={theme["core-05"]}>
          {t("textSearchScreen.noRecentSearch.text")}
        </CenteredLabel>
        <CenteredLabel type={typography["Body-R"]} color={theme["core-06"]}>
          {t("textSearchScreen.searchResult.text")}
        </CenteredLabel>
      </CenteredLabelsContainer>
    </OverLay>
  );
};

export const NoMatchesFound = ({
  handleOnPressExploreProducts,
  t,
  typography,
  theme,
}: NoMatchesProps) => {
  return (
    <OverLay>
      <CenteredLabelsContainer>
        <CenteredLabel type={typography["H3-M"]} color={theme["core-05"]}>
          {t("textSearchScreen.noMatches.inlineText.text")}
        </CenteredLabel>
        <CenteredLabel type={typography["Body-R"]} color={theme["core-06"]}>
          {t("textSearchScreen.noMatches.description.text")}
        </CenteredLabel>
        <Spacer size={SpaceType.Extra} />
        <EmptyViewButton>
          <Button
            category={ButtonCategory.default}
            type={ButtonType.primary}
            title={t("textSearchScreen.exploreProducts.text")}
            onPress={handleOnPressExploreProducts}
            textTypographyStyle={"H3-M"}
          />
        </EmptyViewButton>
      </CenteredLabelsContainer>
    </OverLay>
  );
};

const OverLay = styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }: { theme: DefaultTheme }) => theme["core-02"]};
`;

const CenteredLabelsContainer = styled.View`
  ${({ theme }: { theme: DefaultTheme }) =>
    (theme.isLargeScreen || theme.isTablet) &&
    css`
      max-width: 343px;
    `}
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  justify-content: center;
  align-items: center;
`;
const EmptyViewButton = styled.View`
  width: 100%;
`;

const CenteredLabel = styled(VDBText)`
  margin-bottom: 10px;
  text-align: center;
`;
